import React from 'react';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';
import { format, subDays, addDays, differenceInMinutes, isSameWeek } from 'date-fns';
import { useRef, useEffect } from 'react';
import { useState } from 'react';
import LeftArrow from '../components/svg/leftArrow';
import RightArrow from '../components/svg/rightArrow';
import SettingsIcon from '../components/svg/settings.svg';
import MeetingInfoModal from '../dashBoard/modal/meetingInfoModal';
import { getDefaultMeetingSettings, getMeeetingDetails, getMeetingSummaryFields, getOutstandingTasks } from '../modals';
import './calendarWide.css';
import CloseIcon from '../components/svg/closeIcon';
import OutstandingTasksModal from './modal/OutstandingTasksModal';
import SettingsModal from './modal/settingsModal';
import MeetingSummaryModal from '../dashBoard/modal/MeetingSummaryModal';
import { use } from 'react';
import CalendarModal from './modal/calendarModal';
import AvailabilityToggle from './AvailabilityToggle';
import { useCallback } from 'react';
import DefaultMeetingSettingsModal from '../dashBoard/modal/defaultMeetingSettingsModal';

function CalendarWide() {
  const calendarRef = useRef();
  const [headerMonths, setHeaderMonths] = useState({});
  const { next, prev } = headerMonths;
  const [showMeetingModal, setShowMeetingModal] = useState(false);
  const [showSettingsModal, setShowSettingsModal] = useState(false);
  const [outstandingId, setOutstandingId] = useState(null);
  const [meetingsArray, setMeetingsArray] = useState([]);
  const [meetingData, setMeetingData] = useState([]);
  const [outstandingTasks, setOutstandingTasks] = useState([]);
  const [isCurrentWeek, setIsCurrentWeek] = useState(true);
  const [showOutstandingTasks, setShowOutstandingTasks] = useState(false);
  const [availabilityToggle, setAvailabilityToggle] = useState(true);
  const [showMeetingSummaryDialog, setShowMeetingSummaryDialog] = useState(false);
  const [showAvialablityModal, setShowAvialablityModal] = useState(false);
  const [meetingSummaryFieldsData, setMeetingSummaryFieldsData] = useState({});
  const [meetingId, setMeetingId] = useState(null);
  const [isEdit, setIsEdit] = useState(false);
  const [dotFlag, setDotFlag] = useState(false);
  const [lastData, setLastData] = useState({});
  const [isNoMeetings, setIsNoMeetings] = useState(false);
  const [showDefaultMeetingModal, setShowDefaultMeetingModal] = useState(false);
  const { deleteReasons } = meetingSummaryFieldsData;
  const [tasksList] = useState([
    { title: "Complete student evaluation form", date: "Due today" },
    { title: "Review application materials", date: "Due tomorrow" },
    { title: "Schedule follow-up meeting", date: "Due in 2 days" },
    { title: "Submit progress report", date: "Due in 3 days" },
    { title: "Update student records", date: "Due in 4 days" }
  ]);

  const [clickedMeeting, setClickedMeeting] = useState({});

  const showHideMeetingModal = (bool) => {
    setShowMeetingModal(bool);
    setShowOutstandingTasks(false);
    if (!bool) {
      loadMeetingDetails(lastData);
      const meetingsarray = [...meetingsArray];
      const index = meetingsarray.findIndex((item) => parseInt(item.id) === parseInt(clickedMeeting.meetingId));
      if (index > -1) {
        meetingsarray[index].color = '#DBEDFF';
        meetingsarray[index].textColor = '#1D5EA6';
        setMeetingsArray(meetingsarray);
      }
    }
  };

  const getMeetingInfo = (meetingid) => {
    const [result] = meetingData.filter(({ meetingId }) => {
      return meetingId === parseInt(meetingid);
    });
    setClickedMeeting(result);
    showHideMeetingModal(true);
  };

  const handleEventClick = (clickInfo) => {
    if (clickInfo.event.id === 'null') { return }
    const meetingsarray = [...meetingsArray];
    const index = meetingsarray.findIndex((item) => parseInt(item.id) === parseInt(clickInfo.event.id));
    meetingsarray[index].color = '#1367B2';
    meetingsarray[index].textColor = 'white';
    setMeetingsArray(meetingsarray);
    getMeetingInfo(clickInfo.event.id);
    loadMeetingDetails(lastData, clickInfo.event.id);
  };

  const renderEventContent = ({ event: { start, end, title, id, }, event }) => {
    const difference = differenceInMinutes(end, start);
    const starttime = format(start, 'hh:mm a');
    const endtime = format(end, 'hh:mm a');
    const dotFlag = event._def.extendedProps.dotFlag;
    return (
      <div className="event-container" id={`event-${id}`}>
        {dotFlag ? <div className="event-dot" /> : ""}
        {title !== "Available" ? <p style={{ fontWeight: '400', fontSize: '12px', cursor: 'pointer' }}>
          {title},
          <span
            style={{ fontWeight: '400', fontSize: '12px', cursor: 'pointer' }}
          >
            {' '}
            {starttime}
          </span>
          {/* <span
            style={{ fontWeight: '400', fontSize: '10px', cursor: 'pointer' }}
          >
            {difference <= 30 && ' ' + starttime + ' - ' + endtime}
          </span> */}
        </p> : <> <p style={{ fontWeight: '400', fontSize: '12px' }}>
          {title}
          <span style={{ fontWeight: '400', fontSize: '10px' }}>
            {difference <= 30 && ' ' + starttime + ' - ' + endtime}
          </span>
        </p>
          {difference > 30 && (
            <p style={{ fontWeight: '400', fontSize: '12px' }}>
              {starttime + ' - ' + endtime}
            </p>
          )}</>}
        {/* {difference > 30 && (
          <p style={{ fontWeight: '400', fontSize: '12px', cursor: 'pointer' }}>
            {starttime + ' - ' + endtime}
          </p>
        )} */}
      </div>
    );
  };
  const renderHeaderDates = (args) => {
    return (
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <span>{format(args.date, 'EEEE')}</span>
        <span>{format(args.date, 'd')}</span>
      </div>
    );
  };

  const calendarNavigation = (direction) => {
    const calendarApi = calendarRef.current.getApi();
    direction === 'prev' && calendarApi.prev();
    direction === 'next' && calendarApi.next();
    const prev = format(calendarApi.getDate(), 'MMMM');
    const next = format(addDays(calendarApi.getDate(), 6), 'MMMM');
    setHeaderMonths({ next, prev });
    setIsCurrentWeek(isSameWeek(calendarApi.getDate(), new Date()));
    loadMeetingDetails({
      startDate: format(calendarApi.getDate(), 'yyyy-MM-dd'),
      endDate: format(addDays(calendarApi.getDate(), 6), 'yyyy-MM-dd'),
    });
  };
  const refreshData = () => {
    loadMeetingDetails(lastData);
    getOutstandingTasks().then((res) => {
      setOutstandingTasks(res);
    });
  };
  const goToCurrentWeek = () => {
    const calendarApi = calendarRef.current.getApi();
    calendarApi.gotoDate(new Date());
    const next = format(new Date(), 'MMMM');
    let day = format(new Date(), 'EEEE');
    let decreaseBy =
      day === 'Sunday'
        ? 0
        : day === 'Monday'
          ? 1
          : day === 'Tuesday'
            ? 2
            : day === 'Wednesday'
              ? 3
              : day === 'Thursday'
                ? 4
                : day === 'Friday'
                  ? 5
                  : day === 'Saturday' && 6;

    const prev = format(subDays(new Date(), decreaseBy), 'MMMM');
    setHeaderMonths({ next, prev });
    setIsCurrentWeek(true);
    loadMeetingDetails({
      startDate: format(
        subDays(calendarApi.getDate(), decreaseBy),
        'yyyy-MM-dd'
      ),
      endDate: format(
        addDays(calendarApi.getDate(), 6 - decreaseBy),
        'yyyy-MM-dd'
      ),
    });
  };
  const goToDate = (date) => {
    const calendarApi = calendarRef.current.getApi();
    calendarApi.gotoDate(new Date(date));
    const prev = format(calendarApi.getDate(), 'MMMM');
    const next = format(addDays(calendarApi.getDate(), 6), 'MMMM');
    setHeaderMonths({ next, prev });
    setIsCurrentWeek(true);
    loadMeetingDetails({
      startDate: format(calendarApi.getDate(), 'yyyy-MM-dd'),
      endDate: format(addDays(calendarApi.getDate(), 6), 'yyyy-MM-dd'),
    });
  };
  const createMeetingArray = (data) => {
    try {
      let meetingarr = [];
      if (data.length > 0) {
        let filteredData = data;
        if (!availabilityToggle) {
          filteredData = data.filter((item) => item.appointmentStatus !== 'Available');
        }
        filteredData.map((item) => {
          const {
            meetingStartTime,
            meetingEndTime,
            meetingDate,
            meetingId,
            studentDetail,
            appointmentStatus,
            dotFlag,
            busy
          } = item;
          meetingarr.push({
            start: `${meetingDate}T${meetingStartTime.split(':')[0] +
              ':' +
              meetingStartTime.split(':')[1]
              }`,
            end: `${meetingDate}T${meetingEndTime.split(':')[0] + ':' + meetingEndTime.split(':')[1]
              }`,
            id: meetingId,
            title: busy ? "Busy" : (!studentDetail && appointmentStatus === 'Available') ? "Available" : (studentDetail || [])[0]?.fullName
              ? ((studentDetail || [])[0].fullName.length > 15
                ? (studentDetail || [])[0].fullName.slice(0, 15) + '...'
                : (studentDetail || [])[0].fullName)
              : 'Available ',
            color: busy ? "#B40505" : appointmentStatus === 'Available' ? '#F1FFEA' : '#EAF5FF',
            textColor: busy ? "white" : appointmentStatus === 'Available' ? 'black' : '#1D5EA6',
            dotFlag: dotFlag,

          });
        });
      }
      setMeetingsArray(meetingarr);
    } catch (error) {
      console.log('create meeting array', error);
    }
  };

  const loadMeetingDetails = async (data, id) => {
    try {
      if (Object.keys(data).length === 0) {
        return;
      }
      setLastData(data);
      const result = await getMeeetingDetails(data);

      setMeetingData(result);
      createMeetingArray(result);
      if (id) {
        const [result1] = result.filter((a) => {
          return parseInt(id) === parseInt(a.meetingId);
        });
        setClickedMeeting(result1);
      }
    } catch (error) {
      console.log('meeting details', error);
    }
  };

  useEffect(() => {
    let timezonediv = document.getElementsByClassName(
      'fc-timegrid-axis-frame'
    )[0];
    timezonediv.innerHTML += '<span class="timezone-calendar"><span>';
    const calendarApi = calendarRef.current.getApi();
    const next = format(calendarApi.getDate(), 'MMMM');
    let day = format(calendarApi.getDate(), 'EEEE');
    let decreaseBy =
      day === 'Sunday'
        ? 0
        : day === 'Monday'
          ? 1
          : day === 'Tuesday'
            ? 2
            : day === 'Wednesday'
              ? 3
              : day === 'Thursday'
                ? 4
                : day === 'Friday'
                  ? 5
                  : day === 'Saturday' && 6;

    const prev = format(subDays(calendarApi.getDate(), decreaseBy), 'MMMM');
    setHeaderMonths({ next, prev });
    loadMeetingDetails({
      startDate: format(
        subDays(calendarApi.getDate(), decreaseBy),
        'yyyy-MM-dd'
      ),
      endDate: format(
        addDays(calendarApi.getDate(), 6 - decreaseBy),
        'yyyy-MM-dd'
      ),
    });
  }, []);
  useEffect(() => {
    getMeetingSummaryFields().then((res) => {
      setMeetingSummaryFieldsData(res);
    });
    getOutstandingTasks().then((res) => {
      setOutstandingTasks(res);
    });
    getDefaultMeetingSettings().then((result) => {
      if (Object.keys(result).length === 0) {
        setIsNoMeetings(true);
      } else {
        setIsNoMeetings(false);

      }
    }).catch((error) => {
      setIsNoMeetings(true);

    });
  }, []);

  useEffect(() => {
    if (outstandingTasks.length === 0 && showOutstandingTasks) {
      setShowOutstandingTasks(false);
    }
  }
    , [outstandingTasks.length]);
  useEffect(() => {
    createMeetingArray(meetingData);
  }
    , [availabilityToggle]);
  return (
    <>
      {showAvialablityModal && (
        <CalendarModal
          show={showAvialablityModal}
          showHideModal={(value) => {
            refreshData();
            setShowAvialablityModal(value);
          }}
          editable={true}
          navigationAllowed={false}
          firstTime={false}
          viewOnly={false}
          skipWeeks={false}
        />
      )}
      <div className="schedulerCalendarWide">
        {showMeetingSummaryDialog && <MeetingSummaryModal
          onClose={() => {
            setShowMeetingSummaryDialog(false);
            refreshData();

          }}
          meetingSummaryFieldsData={meetingSummaryFieldsData}
          meetingId={meetingId}
          isEdit={isEdit}
          dotFlag={dotFlag}
        />}

        <div className="schedulerCalanderHeader">
          <div className="title">Calendar</div>
          <div className="monthSelector">
            <span
              onClick={() => {
                calendarNavigation('prev');
              }}
            >
              <LeftArrow />
            </span>
            {calendarRef.current ? (
              (() => {
                const calendarApi = calendarRef.current.getApi();
                const currentDate = calendarApi.getDate();
                const dayOfWeek = currentDate.getDay(); // 0 (Sun) - 6 (Sat)
                const weekStart = subDays(currentDate, dayOfWeek); // Sunday
                const weekEnd = addDays(weekStart, 6); // Saturday
                return `${format(weekStart, 'MMMM d')} - ${format(weekEnd, 'MMMM d')}`;
              })()
            ) : (
              `${prev !== next ? prev + ' - ' + next : prev}`
            )}
            {!isCurrentWeek && (
              <span
                style={{ marginLeft: '10px', cursor: 'pointer' }}
                onClick={goToCurrentWeek}
              >
                <CloseIcon />
              </span>
            )}
            <span
              onClick={() => {
                calendarNavigation('next');
              }}
            >
              <RightArrow />
            </span>
          </div>
          <div className="outstanding-tasks-container">
            {outstandingTasks.length ? <span
              style={{ cursor: 'pointer', position: 'relative' }}
              onClick={() => setShowOutstandingTasks(!outstandingTasks.length ? false : !showOutstandingTasks)}
            >
              <span className="outstanding-tasks-dot"></span>
              {outstandingTasks.length ? outstandingTasks.length : "No"} outstanding tasks

            </span> : ""}
            <button
              className="settings-button"
              onClick={() => {
                setShowOutstandingTasks(false);
                setShowSettingsModal(!showSettingsModal)
              }}
            >
              <img src={SettingsIcon} alt="settings" />
            </button>
            {showOutstandingTasks && (
              <OutstandingTasksModal
                outstandingTasks={outstandingTasks}
                onClose={() => setShowOutstandingTasks(false)}
                setShowAvialablityModal={(value) => {
                  if (isNoMeetings) {
                    setShowDefaultMeetingModal(value);
                  } else {
                    setShowAvialablityModal(value);
                  }
                }}
                removeOutstandingTasks={(index) => {
                  const tasks = [...outstandingTasks];
                  tasks.splice(index, 1);
                  setOutstandingTasks(tasks);
                }
                }
                goToDate={goToDate}
                addMeetingSummary={(id, summaryAdded) => {
                  setMeetingId(id);
                  setIsEdit(summaryAdded);
                  setShowMeetingSummaryDialog(true);
                  setShowOutstandingTasks(false);
                  setDotFlag(true);
                }
                }
              />
            )}

            {showSettingsModal && (
              <SettingsModal onClose={() => {
                setShowSettingsModal(false);
                loadMeetingDetails(lastData);
              }}
              />
            )}
          </div>
        </div>
        {showDefaultMeetingModal ? <SettingsModal
          forFirstTime={true}
          onClose={() => {
            setShowDefaultMeetingModal(false);
            loadMeetingDetails(lastData);
            getDefaultMeetingSettings().then((result) => {
              if (Object.keys(result).length === 0) {
                setIsNoMeetings(true);
              } else {
                setIsNoMeetings(false);

              }
            }).catch((error) => {
              setIsNoMeetings(true);

            });
          }}
        /> : ""}
        <div className="calanderboxWrapper calendar-wide">
          <FullCalendar
            ref={calendarRef}
            plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
            slotLabelFormat={{
              hour: 'numeric',
              minute: '2-digit',
              omitZeroMinute: false,
              meridiem: 'short',
            }}
            slotMinTime="06:00:00"
            slotMaxTime="23:00:00"
            initialView="timeGridWeek"
            editable={false}
            selectable={false}
            dayMaxEvents={false}
            allDaySlot={false}
            headerToolbar={false}
            dayHeaderFormat={{
              day: 'numeric',
              weekday: 'long',
              omitCommas: true,
            }}
            dayHeaderContent={renderHeaderDates}
            selectOverlap={false}
            weekends={true}
            height="auto"
            events={meetingsArray}
            eventContent={renderEventContent}
            eventClick={handleEventClick}
            eventBackgroundColor="#DBEDFF"
            eventBorderColor="transparent"
            eventTextColor="#1D5EA6"
          />

        </div>
        <div style={{ marginTop: 16 }}>
          <AvailabilityToggle
            checked={availabilityToggle}
            onChange={useCallback((e) => setAvailabilityToggle(e.target.checked), [])}
          />
        </div>
      </div>
      {showMeetingModal && (
        <MeetingInfoModal
          show={showMeetingModal}
          showHideModal={showHideMeetingModal}
          meetingInfo={clickedMeeting}
          fromTitle="Calendar"
          fromLink="/calendar"
          handleMeetingSummary={() => {
            setMeetingId(clickedMeeting.meetingId);
            setIsEdit(clickedMeeting.summaryAdded ? true : false);
            setShowMeetingSummaryDialog(true);
            showHideMeetingModal(false);
            setDotFlag(clickedMeeting.summaryAdded ? true : false);
          }}
          deleteReasons={!deleteReasons ? [] : deleteReasons}
        />
      )}

    </>
  );
}

export default CalendarWide;
